export default "__VITE_ASSET__0jBgcgk4__"